// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx, ParamComponent } from 'panel';
import range from 'lodash/range';
import { selx } from 'clsx';
import { InputEl } from 'common/components/input';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { apiClient } from 'common/util/api-client';
import { getProjectId } from 'common/report/util';
import { FeedbackForFeature, Sentiment } from 'common/widgets/feedback-modal/types';
import { unsetUserFlag } from 'common/report/queries/app-api/user-flags';
import { UserFlag } from 'common/report/constants';
import { getLocation } from 'common/util/url';
import css from './index.module.styl?inline';
import styles from './index.module.styl';
interface State {
  submittedScore: boolean;
  score: number;
  feedback: string;
}
interface Params {
  email: string;
  onActionCallback: () => void;
  orgId: number;
}
interface OnboardingChecklistSurveyJsxProps {
  params?: Params;
}
export class OnboardingChecklistSurvey extends ParamComponent<Params, State> {
  get config() {
    return {
      css,
      useShadowDom: true,
      defaultState: {
        open: true,
        submittedScore: false,
        score: 0,
        feedback: ""
      },
      params: {
        email: String,
        onActionCallback: Function,
        orgId: Number
      },
      helpers: {
        handleClickScore: (score: number) => {
          mixpanel.track("[Onboarding Checklist] Product Feedback", {
            score,
            project_id: getProjectId(),
            organization_id: this.params.orgId
          });
          this.update({
            submittedScore: true,
            score
          });
          unsetUserFlag(UserFlag.EnableOnboardingChecklist);
        },
        handleTextInput: _ref => {
          let {
            target
          } = _ref;
          this.update({
            feedback: target.value
          });
        },
        handleClickDismiss: () => {
          unsetUserFlag(UserFlag.EnableOnboardingChecklist);
          this.params.onActionCallback();
        },
        handleClickSubmit: () => {
          // TODO (Sonya) - /me API is so slow that by the time users gets to this point user metadata is not loaded
          if (this.params.email) {
            apiClient.post("/api/app/projects/".concat(getProjectId(), "/product-feedback"), {
              feature: FeedbackForFeature.OnboardingChecklist,
              feedback: this.state.feedback,
              feedback_type: "Unspecified",
              sentiment: this.state.score < 3 ? Sentiment.Negative : Sentiment.Positive,
              customer_email: this.params.email,
              url: getLocation().href
            });
          }
          this.params.onActionCallback();
        }
      },
      template: () => {
        if (this.state.submittedScore) {
          return <div sel={selx(styles.onboardingCard)}>
              <div sel={selx(styles.onboardingCardHeader)}>
                <div sel={selx(styles.headerText)}>Thank you! Please tell us more.</div>
                <ButtonEl attrs={{
                icon: "x",
                theme: ButtonTheme.Tertiary
              }} on={{
                click: this.helpers.handleClickDismiss
              }} />
              </div>
              <div sel={selx(styles.verbatim)}>
                <InputEl attrs={{
                type: "textarea",
                'auto-focus': true
              }} sel={selx(styles.input)} on={{
                input: this.helpers.handleTextInput
              }} />
                <ButtonEl on={{
                click: this.helpers.handleClickSubmit
              }}>
                  Submit
                </ButtonEl>
              </div>
            </div>;
        }
        return <div sel={selx(styles.onboardingCard)}>
            <div sel={selx(styles.onboardingCardHeader)}>
              <div sel={selx(styles.headerText)}>How would you rate your onboarding experience with Mixpanel?</div>
              <ButtonEl attrs={{
              icon: "x",
              theme: ButtonTheme.Tertiary
            }} on={{
              click: this.helpers.handleClickDismiss
            }} />
            </div>
            <div sel={selx(styles.scores)}>
              {range(1, 6).map(n => {
              return <div sel={selx(styles.option)} on={{
                click: () => {
                  this.helpers.handleClickScore(n);
                }
              }}>
                    {n}
                  </div>;
            })}
            </div>
            <div sel={selx(styles.legend)}>
              <div>Poor</div>
              <div>Excellent</div>
            </div>
          </div>;
      }
    };
  }
}
export const OnboardingChecklistSurveyEl = defineAndMakeJsxFactory<OnboardingChecklistSurveyJsxProps>("mp-onboarding-checklist-survey", OnboardingChecklistSurvey);
export const OnboardingChecklistSurveyReact = panel2react<OnboardingChecklistSurveyJsxProps>("mp-onboarding-checklist-survey", OnboardingChecklistSurvey);